import React, { useState, useCallback, useEffect, useRef } from 'react';
import SalesFilters from './SalesFilters';
import SimpleTabs from './SimpleTabs';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { X, Overview, DownloadIcon, ChevronDown, ChevronUp } from 'lucide-react';
import ProjectTab from './ProjectTab';
import { Tooltip } from '@material-tailwind/react';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import CustomCollapseCard from '../../components/CustomCollapseCard';

function IncomeReports({ scheduledData, slabwiseData, hybridData, projectDetails }) {
    console.log("Hybrid data received:", hybridData?.length || 0, "installments (mix of SCHEDULED/SLAB/TOKEN/DOWN payment types)");
    
    console.log("hybridData",hybridData)
    // Log the actual payment types in hybrid data
    if (hybridData?.length > 0) {
        const paymentTypes = [...new Set(hybridData.map(item => item.paymentType?.type))];
        console.log("Payment types in hybrid data:", paymentTypes);
    }
    
    const [projectFilter, setProjectFilter] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [activeProjectTabs, setActiveProjectTabs] = useState({});
    const [nextTabId, setNextTabId] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedConfig, setSelectedConfig] = useState('all');
    const [selectedBuilding, setSelectedBuilding] = useState('all');
    const [timePeriod, setTimePeriod] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const gridRefScheduled = useRef(null);
    const gridRefSlabwise = useRef(null);
    const gridRefHybrid = useRef(null);
    const [projects, setProjects] = useState([]);
    const [expandedSections, setExpandedSections] = useState({
        scheduled_payment: false,
        slab_wise_payment: false,
        token_payment: false,
        down_payment: false
    });

    const getProjectName = (item) => {
        return item?.customerSales?.propertyData?.projectPhase?.project?.projectName || 'Unknown Project';
    };

    const getProject = (item) => {
        return item?.customerSales?.propertyData?.projectPhase?.project  || null;
    };

    useEffect(() => {



        const allScheduledProjects = scheduledData.map((item) => getProject(item));
        const allSlabwiseProjects = slabwiseData.map((item) => getProject(item));
        const allHybridProjects = hybridData.map((item) => getProject(item));
        const combinedProjects = [...allScheduledProjects, ...allSlabwiseProjects, ...allHybridProjects];
        const uniqueProjectNames = [...new Set(combinedProjects.map(p => p?.projectName))];
        setProjects(combinedProjects);

        
    }, [scheduledData, slabwiseData, hybridData]);

    const uniqueProjects = ['all', ...new Set(projects.map(p => p?.projectName))];

    const filterData = useCallback((data) => {
        
        return data.filter((item) => {
            const projectName = getProjectName(item);
            const projectMatch = !projectFilter || projectFilter === 'all' || projectName === projectFilter;

            let dateMatch = true;
            if (dateFrom && dateTo) {
                try {
                    const targetDate = new Date(item.projectedDate || item.receivedDate);
                    const startDateObj = new Date(dateFrom);
                    const endDateObj = new Date(dateTo);

                    if (!isNaN(targetDate)) {
                        dateMatch = targetDate >= startDateObj && targetDate <= endDateObj;
                    } else {
                        dateMatch = false;
                    }
                } catch (err) {
                    console.error(err);
                    dateMatch = false;
                }
            }

            const result = projectMatch && dateMatch;
            
            return result;
        });
    }, [projectFilter, dateFrom, dateTo]);

    const filteredScheduledData = filterData(scheduledData);
    const filteredSlabwiseData = filterData(slabwiseData);
    const filteredHybridData = filterData(hybridData);


    const ProjectLink = useCallback(({ project, installmentType }) => {
        
        return (
            <Tooltip  placement="right">
                <Tooltip.Trigger><button
                    onClick={() => {
                        console.log(`Opening project ${project.projectName} with installment types:`, installmentType);
                        setActiveProjectTabs((prevTabs) => {
                            const newTabId = nextTabId;
                            setNextTabId(nextTabId + 1);

                            // Create a unique key using project name + tab ID to allow multiple tabs for same project
                            const uniqueKey = `${project.projectName}_${newTabId}`;

                            const updatedTabs = {
                                ...prevTabs,
                                [uniqueKey]: {
                                    id: newTabId,
                                    projectName: project.projectName,
                                    project: project,
                                    installmentType: installmentType,
                                },
                            };

                            const newTabIndex = 3 + Object.keys(updatedTabs).length - 1;

                            setTimeout(() => {
                                setActiveTabIndex(newTabIndex);
                            }, 0);

                            return updatedTabs;
                        });
                    }}
                    className="text-blue-500 hover:underline focus:outline-none"
                >
                    {project.projectName}
                </button></Tooltip.Trigger>
           
             <Tooltip.Content className="bg-slate-800 text-white font-normal text-sm max-w-xs w-48">
            Click to view installments for {project.projectName}
                 <Tooltip.Arrow />
             </Tooltip.Content>
             </Tooltip>
        );
    }, [nextTabId, setActiveProjectTabs, setActiveTabIndex]);

    const calculateCumulativeAmountsScheduled = useCallback((data) => {
     
        const cumulativeData = {};

        data.forEach(item => {
            const projectName = getProjectName(item);


            if (!cumulativeData[projectName]) {
                const project = projects.find(p => p?.projectName === projectName);
                cumulativeData[projectName] = {
                    projectName: projectName,
                    cumulativeReceivedAmount: 0,
                    cumulativeProjectedAmount: 0,
                    project: project // Ensure this is the correct project from projects array
                };
            }

            cumulativeData[projectName].cumulativeReceivedAmount += (item.receivedAmount || 0);
            cumulativeData[projectName].cumulativeProjectedAmount += (item.projectedAmount || 0);
        });

        const result = Object.values(cumulativeData);
        
        return result;
    }, [projects]);

    const calculateCumulativeAmountsSlabwise = useCallback((data) => {
        
        const cumulativeData = {};

        data.forEach(item => {
            const projectName = getProjectName(item);


            if (!cumulativeData[projectName]) {
                const project = projects.find(p => p?.projectName === projectName);
                cumulativeData[projectName] = {
                    projectName: projectName,
                    cumulativeReceivedAmount: 0,
                    cumulativeProjectedAmount: 0,
                    project: project // Ensure this is the correct project from projects array
                };

            }

            cumulativeData[projectName].cumulativeReceivedAmount += (item.receivedAmount || 0);
            cumulativeData[projectName].cumulativeProjectedAmount += (item.projectedAmount || 0);
        });

        const result = Object.values(cumulativeData);
        
        return result;
    }, [projects]);

    const cumulativeScheduledData = calculateCumulativeAmountsScheduled(filteredScheduledData);
    const cumulativeSlabwiseData = calculateCumulativeAmountsSlabwise(filteredSlabwiseData);
    
    // Calculate cumulative amounts for hybrid data by project
    const calculateCumulativeAmountsHybrid = useCallback((data) => {
        const cumulativeData = {};

        data.forEach(item => {
            const projectName = getProjectName(item);

            if (!cumulativeData[projectName]) {
                const project = projects.find(p => p?.projectName === projectName);
                cumulativeData[projectName] = {
                    projectName: projectName,
                    cumulativeReceivedAmount: 0,
                    cumulativeProjectedAmount: 0,
                    project: project
                };
            }

            cumulativeData[projectName].cumulativeReceivedAmount += (item.receivedAmount || 0);
            cumulativeData[projectName].cumulativeProjectedAmount += (item.projectedAmount || 0);
        });

        const result = Object.values(cumulativeData);
        
        return result;
    }, [projects]);

    const cumulativeHybridData = calculateCumulativeAmountsHybrid(filteredHybridData);
    
    // For detailed view, show individual installments grouped by payment type
    const hybridInstallmentsData = filteredHybridData.map(item => ({
        ...item,
        projectName: getProjectName(item)
    }));
    
    console.log("Hybrid installments data:", hybridInstallmentsData);

    // Group hybrid data by payment type
    const groupedHybridData = useCallback(() => {
        const scheduled = [];
        const slabwise = [];
        const token = [];
        const down = [];

        hybridInstallmentsData.forEach(item => {
            const paymentType = item.paymentType?.type;
            switch (paymentType) {
                case 'SCHEDULED_PAYMENT':
                    scheduled.push(item);
                    break;
                case 'SLAB_WISE_PAYMENT':
                    slabwise.push(item);
                    break;
                case 'TOKEN_PAYMENT':
                    token.push(item);
                    break;
                case 'DOWN_PAYMENT':
                    down.push(item);
                    break;
                default:
                    // If no specific type, add to scheduled as fallback
                    scheduled.push(item);
                    break;
            }
        });

        return {
            scheduled,
            slabwise,
            token,
            down
        };
    }, [hybridInstallmentsData]);

    const hybridGroups = groupedHybridData();


    const scheduledColumnDefs = [
        {
            field: 'projectName',
            headerName: 'Project Name',
            cellRenderer: (params) => {

                const project = projects.find(item => item.projectName === params.data.projectName);

                return project ? <ProjectLink project={project} installmentType={["SCHEDULED_PAYMENT", "TOKEN_PAYMENT", "DOWN_PAYMENT"]} /> : 'Unknown Project';
            },
        },
        {
            field: 'cumulativeReceivedAmount',
            headerName: 'Cumulative Received (₹)',
            valueFormatter: (params) => {
                const amount = params.value;
                if (amount !== null && amount !== undefined) {
                    return '₹' + amount.toLocaleString();
                } else {
                    return '₹0';
                }
            },
        },
        {
            field: 'cumulativeProjectedAmount',
            headerName: 'Cumulative Projected (₹)',
            valueFormatter: (params) => {
                const amount = params.value;
                if (amount !== null && amount !== undefined) {
                    return '₹' + amount.toLocaleString();
                } else {
                    return '₹0';
                }
            },
        },
    ];

    const slabwiseColumnDefs = [
        {
            field: 'projectName',
            headerName: 'Project Name',
            cellRenderer: (params) => {

                const project = projects.find(item => item.projectName === params.data.projectName);

                return project ? <ProjectLink project={project} installmentType={["SLAB_WISE_PAYMENT", "TOKEN_PAYMENT", "DOWN_PAYMENT"]} /> : 'Unknown Project';
            },
        },
        {
            field: 'cumulativeReceivedAmount',
            headerName: 'Cumulative Received (₹)',
            valueFormatter: (params) => {
                const amount = params.value;
                if (amount !== null && amount !== undefined) {
                    return '₹' + amount.toLocaleString();
                } else {
                    return '₹0';
                }
            },
        },
        {
            field: 'cumulativeProjectedAmount',
            headerName: 'Cumulative Projected (₹)',
            valueFormatter: (params) => {
                const amount = params.value;
                if (amount !== null && amount !== undefined) {
                    return '₹' + amount.toLocaleString();
                } else {
                    return '₹0';
                }
            },
        },
    ];

    const hybridColumnDefs = [
        {
            field: 'projectName',
            headerName: 'Project Name',
            cellRenderer: (params) => {
                const project = projects.find(item => item.projectName === params.data.projectName);
                return project ? <ProjectLink project={project} installmentType={["SCHEDULED_PAYMENT", "SLAB_WISE_PAYMENT", "TOKEN_PAYMENT", "DOWN_PAYMENT"]} /> : 'Unknown Project';
            },
        },
        {
            field: 'cumulativeReceivedAmount',
            headerName: 'Cumulative Received (₹)',
            valueFormatter: (params) => {
                const amount = params.value;
                if (amount !== null && amount !== undefined) {
                    return '₹' + amount.toLocaleString();
                } else {
                    return '₹0';
                }
            },
        },
        {
            field: 'cumulativeProjectedAmount',
            headerName: 'Cumulative Projected (₹)',
            valueFormatter: (params) => {
                const amount = params.value;
                if (amount !== null && amount !== undefined) {
                    return '₹' + amount.toLocaleString();
                } else {
                    return '₹0';
                }
            },
        },
    ];

    // Column definitions for individual hybrid sections
    const hybridSectionColumnDefs = [
        {
            field: 'customerSalesInstallmentId',
            headerName: 'Installment ID',
            sortable: true,
            filter: true,
            flex: 1,
        },
        {
            field: 'projectName',
            headerName: 'Project Name',
            cellRenderer: (params) => {
                const project = projects.find(item => item.projectName === params.data.projectName);
                return project ? <ProjectLink project={project} installmentType={["SCHEDULED_PAYMENT", "SLAB_WISE_PAYMENT", "TOKEN_PAYMENT", "DOWN_PAYMENT"]} /> : 'Unknown Project';
            },
            flex: 2,
        },
        {
            field: 'projectedAmount',
            headerName: 'Projected Amount (₹)',
            sortable: true,
            filter: true,
            flex: 1,
            valueFormatter: (params) => {
                const amount = params.value;
                if (amount !== null && amount !== undefined) {
                    return '₹' + amount.toLocaleString();
                } else {
                    return '₹0';
                }
            },
        },
        {
            field: 'receivedAmount',
            headerName: 'Received Amount (₹)',
            sortable: true,
            filter: true,
            flex: 1,
            valueFormatter: (params) => {
                const amount = params.value;
                if (amount !== null && amount !== undefined) {
                    return '₹' + amount.toLocaleString();
                } else {
                    return '₹0';
                }
            },
        },
        {
            field: 'projectedDate',
            headerName: 'Projected Date',
            sortable: true,
            filter: true,
            flex: 1,
            valueFormatter: (params) => {
                return params.value ? new Date(params.value).toLocaleDateString('en-GB') : '';
            },
        },
        {
            field: 'receivedDate',
            headerName: 'Received Date',
            sortable: true,
            filter: true,
            flex: 1,
            valueFormatter: (params) => {
                return params.value ? new Date(params.value).toLocaleDateString('en-GB') : '';
            },
        },
    ];

    const defaultColDef = {
        sortable: true,
        filter: true,
        resizable: true,
    };

    const onGridReady = useCallback((params) => {
        params.api.sizeColumnsToFit();
    }, []);

    const closeProjectTab = useCallback((uniqueKey) => {
        setActiveProjectTabs((prevTabs) => {
            const updatedTabs = { ...prevTabs };
            delete updatedTabs[uniqueKey];
            return updatedTabs;
        });
        setActiveTabIndex(0);
    }, [setActiveProjectTabs, setActiveTabIndex]);

    const toggleSection = useCallback((section) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    }, []);

    const exportScheduledToCsv = useCallback(() => {
        const csvExportParams = {
            fileName: 'scheduled_income.csv',
        };
        gridRefScheduled.current.api.exportDataAsCsv(csvExportParams);
    }, []);

    const exportSlabwiseToCsv = useCallback(() => {
        const csvExportParams = {
            fileName: 'slabwise_income.csv',
        };
        gridRefSlabwise.current.api.exportDataAsCsv(csvExportParams);
    }, []);

    const exportHybridToCsv = useCallback(() => {
        const csvExportParams = {
            fileName: 'hybrid_income.csv',
        };
        gridRefHybrid.current.api.exportDataAsCsv(csvExportParams);
    }, []);

    const ScheduledIncomeTable = () => {
        
        return (
            <>
                <div className="flex justify-end mb-2">
                   
                </div>
                <div className="ag-theme-quartz font-normal mt-4" style={{ height: 400, width: '100%' }}>

                    <AgGridReact
                        ref={gridRefScheduled}
                        rowData={cumulativeScheduledData}
                        columnDefs={scheduledColumnDefs}
                        defaultColDef={defaultColDef}
                        rowSelection="single"
                        animateRows={true}
                        onGridReady={onGridReady}
                        onFirstDataRendered={params => {
                            params.api.sizeColumnsToFit();
                        }}
                    />
                </div>
            </>
        );
    };

    const SlabwiseIncomeTable = () => {
      
        return (
            <>
                <div className="flex justify-end mb-2">
                   
                </div>
                <div className="ag-theme-quartz font-normal mt-4" style={{ height: 400, width: '100%' }}>

                    <AgGridReact
                        ref={gridRefSlabwise}
                        rowData={cumulativeSlabwiseData}
                        columnDefs={slabwiseColumnDefs}
                        defaultColDef={defaultColDef}
                        rowSelection="single"
                        animateRows={true}
                        onGridReady={onGridReady}
                        onFirstDataRendered={params => {
                            params.api.sizeColumnsToFit();
                        }}
                    />
                </div>
            </>
        );
    };

    const HybridIncomeTable = () => {
        return (
            <>
                <div className="flex justify-end mb-2">
                   
                </div>
                <div className="ag-theme-quartz font-normal mt-4" style={{ height: 400, width: '100%' }}>

                    <AgGridReact
                        ref={gridRefHybrid}
                        rowData={cumulativeHybridData}
                        columnDefs={hybridColumnDefs}
                        defaultColDef={defaultColDef}
                        rowSelection="single"
                        animateRows={true}
                        onGridReady={onGridReady}
                        onFirstDataRendered={params => {
                            params.api.sizeColumnsToFit();
                        }}
                    />
                </div>
            </>
        );
    };

    const tabData = [
        {
            label: 'Scheduled',
            content: (
                <>
                    <div className=" flex gap-2 filter-section rounded-md bg-gray-100">

                        <SalesFilters
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            selectedConfig={selectedConfig}
                            setSelectedConfig={setSelectedConfig}
                            selectedBuilding={selectedBuilding}
                            setSelectedBuilding={setSelectedBuilding}
                            startDate={startDate}
                            setStartDate={setStartDate}
                            endDate={endDate}
                            setEndDate={setEndDate}
                            timePeriod={timePeriod}
                            setTimePeriod={setTimePeriod}
                            uniqueConfigs={['all']}
                            uniqueBuildings={['all']}
                            showSearchTerm={true}

                        />
                        <select
                            id="incomeProjectFilter"
                            value={projectFilter}
                            onChange={(e) => setProjectFilter(e.target.value)}
                            className="p-2 border rounded w-40 h-1/2 md:w-auto font-normal text-sm"
                        >
                            {uniqueProjects.map((project) => (
                                <option key={project} value={project}>
                                    {project === 'all' ? 'All Projects' : project}
                                </option>
                            ))}
                        </select>
                        <button className="flex items-center gap-2 font-medium text-sm text-white bg-green-600 hover:bg-green-700 p-2 rounded shadow-md" onClick={exportScheduledToCsv}>
                                <DownloadIcon size={18} /> Export
                            </button>
                    </div>
                   
                    <ScheduledIncomeTable />
                </>
            ),
            id: 1,
        },
        {
            label: 'Slab',
            content: (
                <>
                    <div className=" flex gap-3 filter-section rounded-md bg-gray-100">

                        <SalesFilters
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            selectedConfig={selectedConfig}
                            setSelectedConfig={setSelectedConfig}
                            selectedBuilding={selectedBuilding}
                            setSelectedBuilding={selectedBuilding}
                            startDate={startDate}
                            setStartDate={setStartDate}
                            endDate={endDate}
                            setEndDate={setEndDate}
                            timePeriod={timePeriod}
                            setTimePeriod={setTimePeriod}
                            uniqueConfigs={['all']}
                            uniqueBuildings={['all']}

                            showSearchTerm={true}
                        />
                        <select
                            id="incomeProjectFilter"
                            value={projectFilter}
                            onChange={(e) => setProjectFilter(e.target.value)}
                            className="p-2  border rounded w-40 h-1/2 md:w-auto font-normal text-sm"
                        >
                            {uniqueProjects.map((project) => (
                                <option key={project} value={project}>
                                    {project === 'all' ? 'All Projects' : project}
                                </option>
                            ))}
                        </select>
                        <button className="flex items-center gap-2 font-medium text-sm text-white bg-green-600 hover:bg-green-700 p-2 rounded shadow-md" onClick={exportSlabwiseToCsv}>
                                <DownloadIcon size={18} /> Export
                            </button>
                    </div>

                    <SlabwiseIncomeTable />
                </>
            ),
            id: 2,
        },
        {
            label: 'Hybrid',
            content: (
                <>
                    <div className=" flex gap-3 filter-section rounded-md bg-gray-100">

                        <SalesFilters
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            selectedConfig={selectedConfig}
                            setSelectedConfig={setSelectedConfig}
                            selectedBuilding={selectedBuilding}
                            setSelectedBuilding={selectedBuilding}
                            startDate={startDate}
                            setStartDate={setStartDate}
                            endDate={endDate}
                            setEndDate={setEndDate}
                            timePeriod={timePeriod}
                            setTimePeriod={setTimePeriod}
                            uniqueConfigs={['all']}
                            uniqueBuildings={['all']}
                            showSearchTerm={true}
                        />
                        <select
                            id="incomeProjectFilter"
                            value={projectFilter}
                            onChange={(e) => setProjectFilter(e.target.value)}
                            className="p-2  border rounded w-40 h-1/2 md:w-auto font-normal text-sm"
                        >
                            {uniqueProjects.map((project) => (
                                <option key={project} value={project}>
                                    {project === 'all' ? 'All Projects' : project}
                                </option>
                            ))}
                        </select>
                        <button className="flex items-center gap-2 font-medium text-sm text-white bg-green-600 hover:bg-green-700 p-2 rounded shadow-md" onClick={exportHybridToCsv}>
                                <DownloadIcon size={18} /> Export
                            </button>
                    </div>

                    <HybridIncomeTable />
                </>
            ),
            id: 3,
        },
        ...Object.entries(activeProjectTabs).map(([uniqueKey, tab]) => {
          
            return ({
                label: (
                    <div className="flex items-center">
                        {tab.project.projectName}
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                closeProjectTab(uniqueKey);
                            }}
                            className="ml-2"
                        >
                            <X size={16} />
                        </button>
                    </div>
                ),
                content: <ProjectTab project={tab.project} tabId={tab.id} installmentType={tab.installmentType} />,
                id: tab.id,
            });
        }),
    ];

    return (
        <div id="incomeReports" >
            <SimpleTabs tabs={tabData} activeTab={activeTabIndex} setActiveTab={setActiveTabIndex} />
        </div>
    );
}

export default IncomeReports;